import { render, staticRenderFns } from "./ConsultaCpf.vue?vue&type=template&id=03a4f24c&scoped=true"
import script from "./ConsultaCpf.vue?vue&type=script&lang=js"
export * from "./ConsultaCpf.vue?vue&type=script&lang=js"
import style0 from "./ConsultaCpf.vue?vue&type=style&index=0&id=03a4f24c&prod&scoped=true&lang=css"
import style1 from "./ConsultaCpf.vue?vue&type=style&index=1&id=03a4f24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4f24c",
  null
  
)

export default component.exports